"use strict";

angular
    .module("internal.exams")
    .controller("InternalExamFormDetails", ["$scope", function($scope) {}]);
